module.exports = __webpack_public_path__ + "img/product1.f1d57ce7.png";